// Показ итогов инвентаризации. Общий модуль для сервера (PDF-свод) и десктопа:
// если каждый отформатирует по-своему, бумага и экран разойдутся в первый же
// месяц, и спорить будет не о чем — обе цифры «правильные».

// Объём храним в мл, а показываем в литрах: 700 мл → «0,7 л». Остальные
// единицы — как есть, в родной (кг, шт, стакан).
export function fmtSummaryTotal(total: number, unit: string): string {
  if (unit === "мл") {
    return `${(total / 1000).toLocaleString("ru-RU", { maximumFractionDigits: 3 })} л`;
  }
  return `${total.toLocaleString("ru-RU", { maximumFractionDigits: 3 })} ${unit}`;
}

// Единица для подписи колонок и дельт: «мл» показываем как «л».
export function displayUnit(unit: string): string {
  return unit === "мл" ? "л" : unit;
}

// Число в той же шкале, что и `fmtSummaryTotal`, но без единицы — для дельт,
// где знак и единица подписываются отдельно.
export function fmtSummaryNumber(value: number, unit: string): string {
  const n = unit === "мл" ? value / 1000 : value;
  return n.toLocaleString("ru-RU", { maximumFractionDigits: 3 });
}
